"use client";
import { IStyleProps } from "../interface";
import { SelectProps, Select, MenuItemProps } from "@mui/material";
import React, {
    ReactElement,
    ReactNode,
    useCallback,
    useEffect,
    useMemo,
    useState,
} from "react";
import stl from "../styles/select.module.scss";
import classnames from "classnames";
import FmMenuItem from "./FmMenuItem";
export interface IProps<T>
    extends IStyleProps,
        Omit<SelectProps<T>, "variant">,
        IContentProps {
    contentWrapper?: (children: ReactNode, props: IProps<T>) => ReactElement; // 包裹selectList
    itemClick?(value: T): void;
    variant?: SelectProps<T>["variant"];
}

interface IContentProps {
    dataList: IContentItem[];
}

export interface IContentItem extends MenuItemProps {
    value: string | number;
    label: string;
    default?: boolean;
}

const FmSelect: React.FC<IProps<string | number>> = (props) => {
    const { dataList, onOpen, contentWrapper, itemClick, ...rest } = useMemo(
        () => props,
        [props],
    );
    const [open, setOpen] = useState(props.open);
    useEffect(() => {
        setOpen(props.open);
    }, [props.open]);
    const defaultClasses = useMemo(() => {
        return {
            outlined: classnames(
                stl["select-root"],
                "select-outlined-----input",
            ),
            // select: classnames("select-input"),
        };
    }, []);
    const classes = useMemo(() => {
        return {
            ...defaultClasses,
            icon: classnames(stl["icon-config-class"], "icon-config-class"),
            select: classnames("select-input"),
            notchedOutline: classnames(
                "notchedOutline-classnames",
                stl["notchedOutline"],
            ),
            ...props.classes,
        };
    }, [defaultClasses, props.classes]);

    const contentList = props.dataList.map((content) => {
        const { value, label, className, ...res } = content;
        return (
            <FmMenuItem
                key={value}
                value={value}
                {...res}
                className={classnames(
                    stl["menu-item"],
                    "menu-item",
                    {
                        [classnames(stl["active-item"], "active-item")]:
                            props.value === value,
                    },
                    className,
                )}
                onClick={() => itemClick?.(value)}
            >
                {label}
            </FmMenuItem>
        );
    });

    const handleOpen = useCallback(
        (e: React.SyntheticEvent<Element, Event>) => {
            setOpen(true);
            onOpen?.(e);
        },
        [onOpen],
    );

    return (
        <Select
            labelId={props.labelId}
            id={props.id}
            open={open}
            onClose={props.onClose}
            onOpen={handleOpen}
            value={props.value}
            label={props.label}
            onChange={props.onChange}
            classes={classes}
            {...rest}
            className={classnames(
                stl["outline-input-by-classname"],
                "outline-input-by-classname",
                stl["root-select"],
                props.className,
            )}
            native={!!props.native}
            variant={props.variant || "outlined"}
        >
            {contentWrapper
                ? contentWrapper(contentList, { ...props, open })
                : contentList}
        </Select>
    );
};

export default FmSelect;
